import { useEffect, useState } from "react";
import eventBus, { EVENTS_NAMES } from "~/tools/eventBus";

const useAppNewUser = () => {
    const [isNewUser, setIsNewUser] = useState(
        globalThis.localStorage.getItem("__uxuy_dex_cached_is_new_user__") !==
            "false"
    );

    useEffect(() => {
        const handleNewUserChanges = (isNew: boolean) => {
            setIsNewUser(isNew);
        };

        eventBus.on(EVENTS_NAMES.NEW_USER_CHANGED, handleNewUserChanges);

        return () => {
            eventBus.off(EVENTS_NAMES.NEW_USER_CHANGED, handleNewUserChanges);
        };
    }, []);

    return isNewUser;
};

export const markAsNormalUser = () => {
    globalThis.localStorage.setItem("__uxuy_dex_cached_is_new_user__", "false");
    eventBus.emit(EVENTS_NAMES.NEW_USER_CHANGED, false);
};

export default useAppNewUser;
